<template>
  <div class="">
    <div class="w-full flex text-c16 font-c4 text-left items-center item cursor-pointer py-3">
      <div class="w-1/4 flex items-center font-c6">
        <icon
          :data="icons.user"
          height="20"
          width="20"
          class="mr-2 cursor-pointer"
          original
        />
        <div>{{ item.person.firstName }} {{ item.person.lastName }}</div>
      </div>

      <div class="w-1/6 ml-4 flex items-center">
        <span v-if="item.person.phone && item.person.phone !== item.person.email">{{ item.person.phone }}</span>
        <span v-if="!item.person.phone || item.person.phone === item.person.email">-</span>
      </div>

      <div class="w-1/4 ml-4">
        <span v-if="item.person.email">{{ item.person.email }}</span>
        <span v-if="!item.person.email">-</span>
      </div>

      <div class="w-1/5 ml-4 flex items-center">
        <span v-if="item.sfd">{{ item.sfd.name }}</span>
        <span v-if="!item.sfd">CCIB</span>
      </div>

      <div class="w-1/6 ml-4 text-center">
        Administrateur
      </div>
      
      <div class="flex items-center justify-center w-40 gap-2">
        <icon
          :data="icons.ic_vueComptable"
          height="20"
          width="20"
          class="cursor-pointer ml-4"
          original
          @click.stop="openLimit"
        />
        <icon
          :data="icons.ic_desactivate"
          height="20"
          width="20"
          class="cursor-pointer"
          original
          @click.stop="handleToggleStatus"
        />
        <icon
          :data="icons.ic_delete"
          height="20"
          width="20"
          class="cursor-pointer"
          original
          @click.stop="handleDelete"
        />
      </div>
    </div>
  </div>
</template>

<script>
import user from '../../../assets/icons/ic-clientAv.svg'
import entreprise from '../../../assets/icons/ic-entreprise.svg'
import ic_delete from "@/assets/icons/ic_delete.svg"
import ic_vueComptable from "@/assets/icons/ic-vueComptable.svg"
import ic_desactivate from "@/assets/icons/ic-desactivate.svg"

export default {
  name: "Liste",
  
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  
  emits: ['delete', 'toggle-status'],
  
  data() {
    return {
      icons: {
        user,
        entreprise,
        ic_delete,
        ic_vueComptable,
        ic_desactivate
      }
    }
  },
  
  methods: {
    handleDelete() {
      // Émettre l'événement avec l'item complet vers le composant parent
      this.$emit('delete', this.item)
    }
    ,
    openLimit() {
      this.$emit('open-view', this.item)
    },
    handleToggleStatus() {
      this.$emit('toggle-status', this.item)
    }
  }
}
</script>

<style lang="scss" scoped>
.svg-icon{
  fill: transparent;
}
.item:hover{
  border-left: 3px groove black;
  padding-left: 30px;
}
</style>
